import { pxToRem } from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';
import { PRODUCT_GALLERY_MEDIA_RADIUS_PX } from './ProductGallery.style';

/** Match ImageSlide tile corners so video slides align with image tiles in the gallery. */
export const VideoContainer: StyleRule = ({ theme }) => ({
    backgroundColor: theme.siteVariables.colors.primitive.black,
    width: '100%',
    height: '100%',
    borderRadius: pxToRem(PRODUCT_GALLERY_MEDIA_RADIUS_PX),
    overflow: 'hidden',
    clipPath: `inset(0 round ${pxToRem(PRODUCT_GALLERY_MEDIA_RADIUS_PX)})`,
});

export const VideoPlayer: StyleRule = () => ({
    width: '100%',
    height: '100%',
});

/**
 * The player when it plays in the slide rather than in its own dialog.
 *
 * `VideoPlayer` renders the cover and the video as siblings, and neither is
 * taken out of the flow: the cover keeps its full height when it fades, so the
 * video lands a whole frame below it and is clipped away by the container —
 * audible, invisible. Both are stacked on the root instead, so the cover fades
 * off the video rather than above it.
 *
 * The root carries `position: relative` here rather than leaning on the
 * player's own styling for it: the children are absolute, and an unpositioned
 * root would hand them the nearest positioned ancestor instead — inside the
 * photo viewer that is the dialog's fixed content, and the video would cover
 * the whole screen rather than its own box.
 */
export const VideoPlayerInline: StyleRule = () => ({
    position: 'relative',
    width: '100%',
    height: '100%',
    '& > *': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
    },
});
